import { Pipe, PipeTransform } from '@angular/core';
import { AfasFunction } from '../classes/afas-function.class';
import { Role } from '../classes/auth/role.class';

@Pipe({
    name: 'isRoleDisabled',
    standalone: false,
})
export class IsRoleDisabledPipe implements PipeTransform {
    transform(func: AfasFunction, role: Role, allRoles: Role[]): boolean {
        // Non-unique roles are never disabled
        if (!role.is_unique) {
            return false;
        }

        // Check if function has any unique role
        const hasUniqueRole = func.roles?.find(r => {
            const roleData = allRoles.find(rd => rd.key === r.key);
            return roleData?.is_unique;
        });

        // If function has a unique role, disable all other unique roles
        if (hasUniqueRole) {
            return hasUniqueRole.key !== role.key;
        }

        // Function has no unique role, so this unique role can be enabled
        return false;
    }
}
